import { gql } from '@apollo/client';

// ─── Subscription Operations ────────────────────────────────────────────────

export const VENDOR_OPPORTUNITY_UPDATED = gql`
  subscription VendorOpportunityUpdated($vendorOpportunityId: ID!) {
    vendorOpportunityUpdated(vendorOpportunityId: $vendorOpportunityId) {
      id
      stage
      dealStatus
      potentialFinanceAmount
    }
  }
`;

export const NOTIFICATION_RECEIVED = gql`
  subscription NotificationReceived($userProfileId: ID!) {
    notificationReceived(userProfileId: $userProfileId) {
      id
      userProfileId
      title
      message
      type
      entityId
      entityType
      createdAt
    }
  }
`;

export const CREDIT_SUBMISSION_UPDATED = gql`
  subscription CreditSubmissionUpdated($vendorOpportunityId: ID!) {
    creditSubmissionUpdated(vendorOpportunityId: $vendorOpportunityId) {
      id
      status
      submissionId
    }
  }
`;

export const DEAL_ACTIVITY_UPDATED = gql`
  subscription DealActivityUpdated($vendorOpportunityId: ID!) {
    dealActivityUpdated(vendorOpportunityId: $vendorOpportunityId) {
      id
      vendorOpportunityId
      type
      subject
      description
      createdBy
      createdAt
    }
  }
`;

export const AI_DECISION_PARSING_COMPLETED = gql`
  subscription AiDecisionParsingCompleted($creditSubmissionId: ID!) {
    aiDecisionParsingCompleted(creditSubmissionId: $creditSubmissionId) {
      creditSubmissionId
      documentId
      success
      errorMessage
      completedAt
    }
  }
`;

export const SMS_ACTIVITY_RECEIVED = gql`
  subscription SmsActivityReceived($vendorOpportunityId: ID!) {
    smsActivityReceived(vendorOpportunityId: $vendorOpportunityId) {
      id
      vendorOpportunityId
      message
      smsDirection
      status
      twilioMessageId
      twilioConversationSid
      createdAt
    }
  }
`;

export const CREDIT_SUBMISSION_PARSING_RUN_UPDATED = gql`
  subscription CreditSubmissionParsingRunUpdated($vendorOpportunityId: ID!) {
    creditSubmissionParsingRunUpdated(vendorOpportunityId: $vendorOpportunityId) {
      parsingRunId
      n8nExecutionId
      documentId
      creditSubmissionId
      vendorOpportunityId
      parsedDecisionId
      status
      errorMessage
      createdDateTime
      modifiedDateTime
    }
  }
`;

export const SUBPRIME_AGENT_SESSION_UPDATED = gql`
  subscription SubprimeAgentSessionUpdated($vendorOpportunityId: ID!) {
    subprimeAgentSessionUpdated(vendorOpportunityId: $vendorOpportunityId) {
      id
      vendorOpportunityId
      sessionId
      status
    }
  }
`;

export const SMS_STATUS_UPDATED = gql`
  subscription SmsStatusUpdated($vendorOpportunityId: ID!) {
    smsStatusUpdated(vendorOpportunityId: $vendorOpportunityId) {
      twilioMessageId
      vendorOpportunityId
      status
    }
  }
`;

export const CONVERSATION_CREATED = gql`
  subscription ConversationCreated($accountId: ID!) {
    conversationCreated(accountId: $accountId) {
      conversationSid
      vendorOpportunityId
      accountId
      createdAt
    }
  }
`;
